export const normalizePagination = (payload = {}, fallbackLimit = 10) => {
    const pagination = payload.pagination || {}
    const limit = Number(pagination.limit || payload.limit || payload.parPage || payload.perPage || fallbackLimit) || fallbackLimit
    const total = Number(
        pagination.total ??
        payload.total ??
        payload.totalItems ??
        payload.totalProduct ??
        payload.totalProducts ??
        payload.totalOrder ??
        payload.totalOrders ??
        payload.totalSeller ??
        payload.totalSellers ??
        payload.totalCustomers ??
        payload.totalTickets ??
        payload.totalApplications ??
        payload.totalNotifications ??
        0
    ) || 0
    const totalPages = Number(
        pagination.totalPages ??
        payload.totalPages ??
        payload.totalPage ??
        payload.pages ??
        (limit > 0 ? Math.ceil(total / limit) : 0)
    ) || 0

    return {
        page: Number(pagination.page || payload.currentPage || payload.page || 1) || 1,
        limit,
        total,
        totalPages
    }
}

export const paginationTotal = (payload = {}, fallbackKey = 'total') => (
    normalizePagination(payload).total || Number(payload[fallbackKey] || 0) || 0
)
